import { DateTime } from 'luxon';

export const getSmartDateLabel = (isoDate: string) => {
  const today = DateTime.local().startOf('day');
  const txnDate = DateTime.fromISO(isoDate).startOf('day');
  const dayDiff = txnDate.diff(today, 'days').days;

  let dayString = 'someday';
  const absDiff = Math.abs(dayDiff);
  switch (dayDiff) {
    case 0:
      dayString = 'today';
      break;
    case -1:
      dayString = 'yesterday';
      break;
    case 1:
      dayString = 'tomorrow';
      break;
    default:
      if (absDiff > 6) {
        if (txnDate.year === today.year) {
          dayString = `on ${txnDate.toFormat('LLL d')}`;
        } else {
          dayString = `on ${txnDate.toFormat('LLL d yyyy')}`;
        }
      } else {
        dayString = dayDiff > 0 ? `In ${dayDiff} days` : `${absDiff} days ago`;
      }
      break;
  }

  return dayString;
};

export const getShortMonthLabelFromISO = (date: string) => DateTime.fromISO(date).toLocaleString({ month: 'short' });

export const getReadableDateRange = (timeStep: string, date1: string, date2: string) => {
  switch (timeStep) {
    case 'DAYS':
      return date1;
    case 'MONTHS':
      return getShortMonthLabelFromISO(date1);
    case 'WEEKS':
      return date1;
    case 'QUARTERS':
      return `${getShortMonthLabelFromISO(date1)} - ${getShortMonthLabelFromISO(date2)}`;
    case 'YEARS':
      return String(DateTime.fromISO(date1).year);
    default:
      return `${date1} - ${date2}`;
  }
};
